import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { accountUserActions } from "../../../../app/accountLoginSlice";
import { USER_LOCALSTORAGE_KEY } from "../../../../shared/const/localstorage";
import {CourseApiResponse} from "../../types/courses/Courses";
import {setCourseData} from "../../slice/courses/coursesSlice";


interface FetchCoursesParams {
    categories?: number[];
}

export const fetchCourses = createAsyncThunk<
    CourseApiResponse,
    FetchCoursesParams
>(
    "courses/fetchCourses",
    async (queryParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<CourseApiResponse>("/api/courses", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: queryParams, // Передаем параметры запроса
            });
            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(accountUserActions.accountUser());
            }

            thunkAPI.dispatch(setCourseData(response.data.data));

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
